import React, { memo } from 'react';
import { Button, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { COMPANY_LIST_TEXT, COMPANY_LIST_URLS } from './constants';

export const ViewMoreButton = memo(() => {
  return (
    <Button
      variant="outlined"
      component={RouterLink}
      to={COMPANY_LIST_URLS.COMPANIES_PAGE}
      endIcon={
        <Box
          component="img"
          src={COMPANY_LIST_URLS.CHEVRON_ICON}
          alt={COMPANY_LIST_TEXT.CHEVRON_ALT}
          sx={{ width: 16, height: 16 }}
        />
      }
      sx={{
        px: 3,
        py: 1.25,
        borderRadius: 2,
        borderColor: "grey.300",
        color: "text.secondary",
        textTransform: "none",
        fontWeight: "medium",
      }}
      aria-label={`${COMPANY_LIST_TEXT.VIEW_MORE_BUTTON} - 導航到公司列表頁面`}
    >
      {COMPANY_LIST_TEXT.VIEW_MORE_BUTTON}
    </Button>
  );
});

ViewMoreButton.displayName = 'ViewMoreButton';
